<script>
    import { onMount } from "svelte";

    export let updateProviderDetailsFormPhase = () => {};

    onMount(() => {
        const topElement = document.getElementById("providerDetailsTopElement");

        if (topElement)
            topElement.scrollIntoView({ behavior: "instant", block: "start" });
    });

    const updateProviderDetails = () => {
        updateProviderDetailsFormPhase(2);
    };
</script>

<div class="flex flex-col gap-y-4 w-full" id="providerDetailsTopElement">
    <div class="flex flex-col gap-y-2">
        <p class="text-[20px] text-gray-600 font-bold w-full">
            Onboarding information
        </p>

        <p class="text-[16px] text-gray-600 w-full">
            We need to collect your information in order to populate invoices
            and receipts that we send to patients, and to sign up your provider
            number to health funds to allow you to bill with Anaemate.
        </p>

        <p class="text-[16px] text-gray-600 w-full">
            To get paid more than Medicare rates, you need to sign up to the
            private health funds, and some public funds (like Worker’s
            compensation and Traffic accident claims) and agree to their terms.
            Certain health funds such as BUPA, HCF and NIB offer both no gap and
            known gap agreements, which you can choose to sign up to. To
            register, Anaemate will need to know which agreements you wish to
            use, and we will send registration forms on your behalf so you can
            start billing.
        </p>
    </div>

    <div class="flex flex-col gap-y-2">
        <p class="text-[20px] text-gray-600 font-bold w-full">
            Provider numbers
        </p>

        <p class="text-[16px] text-gray-600 w-full">
            We need at least one provider number for you to use, but you can
            provide us more than one if you wish. There are two options - you
            can either sign up for a new provider number linked to Anaemate, or
            port over an existing provider number to Anaemate.
        </p>
    </div>

    <div class="flex flex-col gap-y-2">
        <p class="text-[20px] text-gray-600 font-bold w-full">
            Set up a new provider number
        </p>

        <p class="text-[16px] text-gray-600 w-full">
            Please note, any services you wish to bill for, must not be before
            the date a new provider number is set up. If you wish to bill for
            services in the past, please port over an existing provider number
            instead (see below).
        </p>

        <p class="text-[16px] text-gray-600 w-full">
            You can see a video on setting up a new provider number
            <span
                class="underline cursor-pointer font-bold text-secondary"
                on:click|preventDefault={() =>
                    window.open("https://youtu.be/MCnp9ldQgTo", "_blank")}
            >
                here
            </span>
            or follow these steps:
        </p>

        <ol class="pl-6 list-decimal">
            <li>
                Log on to
                <span
                    class="underline cursor-pointer font-bold text-secondary"
                    on:click|preventDefault={() =>
                        window.open(
                            "https://proda.humanservices.gov.au/",
                            "_blank"
                        )}
                >
                    PRODA
                </span>
            </li>
            <li>
                Under Health Professional Online Services, click on 'Go to
                service'
            </li>
            <li>Click on 'My details'</li>
            <li>Click on 'My provider numbers'</li>
            <li>Click on 'Create a new provider location'</li>
            <li>Enter the details for your new provider number location</li>
            <li>
                Under the 'Banking Details' tab, fill in the following details:
                <ul class="pl-6 list-[lower-alpha]">
                    <li>
                        Claiming channel identifier (Medicare Online Minor ID):
                        TCI88888
                    </li>
                    <li>BSB: 062-000</li>
                    <li>Account number: 20420797</li>
                    <li>Account name: TCI HEALTH PTY LTD</li>
                </ul>
            </li>
            <li>
                Submit your application and receive your new provider number
            </li>
        </ol>
    </div>

    <div class="flex flex-col gap-y-2">
        <p class="text-[20px] text-gray-600 font-bold w-full">
            Port over an existing provider number
        </p>

        <p class="text-[16px] text-gray-600 w-full">
            No additional steps are required to port over an existing provider
            number, however you need to be aware that if you plan to use another
            billing provider, any provider number you supply to Anaemate will be
            linked to Anaemate and not to another billing service.
        </p>
    </div>

    <div class="flex w-full">
        <button
            class="btn btn-sm btn-secondary w-full"
            on:click|preventDefault={updateProviderDetails}
        >
            Next
        </button>
    </div>
</div>
